module.exports = __webpack_public_path__ + "static/media/404_path.eac1674f.svg";